import { getFbclid, setFbclid } from '@/apis/campaign'
import { useAccountStore } from '@/stores/account'
import { generateDeviceFingerprint } from '@/utils/fingerprint'
import { getIpFingerprint } from '@/utils/fingerprint/ip'

const getTrigger = async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const trigger = urlParams.get('ltr')
  const trid = urlParams.get('ltrid')

  if (trigger && trid) {
    const triggerString = JSON.stringify({ trigger, trid })
    // Cookie 中保存 ltr 和 ltrid
    document.cookie = `_ltr=${triggerString}; domain=${
      import.meta.env.VITE_COOKIE_DOMAIN
    }; path=/; max-age=7776000`

    // 使用 IP 地址发送给服务端保存
    const ipInfo = await getIpFingerprint()
    if (ipInfo) {
      await setFbclid(`trigger-${ipInfo.ipAddress}`, triggerString)
    }

    // 使用设备指纹发送给服务端保存
    const deviceFingerprint = await generateDeviceFingerprint()
    if (deviceFingerprint) {
      await setFbclid(`trigger-${deviceFingerprint}`, triggerString)
    }

    return {
      trigger,
      trid
    }
  }

  return null
}

const getTriggerByCookie = () => {
  const fbclid = document.cookie.split('; ').find((row) => row.startsWith('_ltr='))
  if (fbclid) {
    const targetValue = fbclid.split('=')[1]
    try {
      return JSON.parse(targetValue)
    } catch (error) {
      console.warn('getTriggerByCookie error', error)
      return null
    }
  }
}

const getTriggerByIp = async () => {
  const ipInfo = await getIpFingerprint()
  if (ipInfo) {
    const { fbclid } = await getFbclid(`trigger-${ipInfo.ipAddress}`)
    if (fbclid) {
      // Cookie 中保存 ltr 和 ltrid
      document.cookie = `_ltr=${fbclid}; domain=${
        import.meta.env.VITE_COOKIE_DOMAIN
      }; path=/; max-age=7776000`
      return JSON.parse(fbclid)
    }
  }

  return null
}

const getTriggerByDeviceFingerprint = async () => {
  const deviceFingerprint = await generateDeviceFingerprint()
  if (deviceFingerprint) {
    const { fbclid } = await getFbclid(`trigger-${deviceFingerprint}`)
    if (fbclid) {
      // Cookie 中保存 ltr 和 ltrid
      document.cookie = `_ltr=${fbclid}; domain=${
        import.meta.env.VITE_COOKIE_DOMAIN
      }; path=/; max-age=7776000`
      return JSON.parse(fbclid)
    }
  }

  return null
}

export const useTrigger = () => {
  const getTriggerByUserId = async () => {
    const triggerByCookie = getTriggerByCookie()
    if (triggerByCookie) {
      return triggerByCookie
    }

    const accountStore = useAccountStore()
    const userId = accountStore.userId
    if (userId) {
      const { fbclid } = await getFbclid(`trigger-${userId}`)
      if (fbclid) {
        try {
          const trigger = JSON.parse(fbclid)
          // Cookie 中保存 ltr 和 ltrid
          document.cookie = `_ltr=${fbclid}; domain=${
            import.meta.env.VITE_COOKIE_DOMAIN
          }; path=/; max-age=7776000`
          return trigger
        } catch (error) {
          2
          console.warn('getTriggerByUserId error', error)
          return null
        }
      }
    }

    return null
  }

  const initTrigger = async (): Promise<{ trigger: string; trid: string } | null> => {
    const trigger = await getTrigger()
    if (!trigger) {
      const triggerByCookie = getTriggerByCookie()
      if (triggerByCookie) {
        return triggerByCookie
      }

      const triggerByIp = await getTriggerByIp()
      if (triggerByIp) {
        return triggerByIp
      }

      const triggerByDeviceFingerprint = await getTriggerByDeviceFingerprint()
      if (triggerByDeviceFingerprint) {
        return triggerByDeviceFingerprint
      }
    }

    return trigger
  }

  return {
    getTriggerByUserId,
    initTrigger
  }
}
